import React from 'react';
import type { ReviewDto } from '@checkfront/guest-experience-api-api-client-javascript-axios';
import { Text } from '@eo-locale/react';
import { Loadable } from '@guest-widgets/shared/src/utils/loadable/loadable';
import { InfiniteScroll } from '@guest-widgets/shared/src/components/InfiniteScroll/InfiniteScroll';
import { Drawer } from '@guest-widgets/shared/src/components/Drawer/Drawer';
import Box from '@mui/material/Box';

import { ReviewList } from './ReviewList';

export interface ReviewsDrawerProps {
  isOpen: boolean;
  reviews: Loadable<ReviewDto[]>;
  totalCount: number;
  onClose(): void;
  loadMore(): void;
}

export const ReviewsDrawer = ({
  isOpen,
  reviews,
  totalCount,
  loadMore,
  onClose,
}: ReviewsDrawerProps) => (
  <Drawer
    title={<Text id="product-details.reviews.title" length={totalCount} />}
    isOpen={isOpen}
    onClose={onClose}
    disableScroll={true}
  >
    <InfiniteScroll
      isLoading={reviews.isLoading}
      onEnd={reviews.value?.length < totalCount ? loadMore : undefined}
    >
      <Box p={4}>
        <ReviewList reviews={reviews.value} />
      </Box>
    </InfiniteScroll>
  </Drawer>
);
